module.exports = __webpack_public_path__ + "d9a86f7dd2a042309b7ee21462fa3e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-helpful.png
// module id = 2040
// module chunks = 4